module.exports = __webpack_public_path__ + "assets/images/new-activity-sparkle.5e529d65a932ef6b930f6fbee8e36477.svg";